export default "__VITE_ASSET__hrtGJG1mSjgciWE7K3mjig__"